module.exports = __webpack_public_path__ + "static/media/bonnie-win.1154ca05.png";